import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-arrivae-products',
  templateUrl: './arrivae-products.component.html',
  styleUrls: ['./arrivae-products.component.css']
})
export class ArrivaeProductsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/platform/customer/arrivae-products/arrivae-products.component.ts